import { Accident } from 'classes';
import ODataUtil from 'utils/ODataUtil';

const apiEndpoint = "/Accident";

const getAccidents = async function getDelays(page, per_page, orderByInfo, orderByDirection, search, filters) {
  const model = Accident;
  const endpoint = apiEndpoint;
  const data = await ODataUtil.gridQuery(page, per_page, orderByInfo, orderByDirection, search, filters, { model, endpoint });
  return data;
}

export { getAccidents };